<template>
    <div class="meetings">
        <div class="content">
            <div class="wrapper">
                <!--<div class="meetings-header" @click="click">-->
                    <!--<el-button type="primary" @click="startMeeting">-->
                        <!--start meeting-->
                    <!--</el-button>-->
                <!--</div>-->
                <vue-jitsi-meet
                        v-if="isMeeting"
                        ref="jitsiRef"
                        domain="mstream.totalflow.io"
                        :options="jitsiOptions"
                ></vue-jitsi-meet>
            </div>
        </div>
      <sign-in-publick-user-to-meeting-modal
          ref="signInPublicUserMeetingModal"
          @connectPublic="connectPublic"/>
    </div>
</template>

<script>
  import { JitsiMeet } from '@mycure/vue-jitsi-meet';
  import axios from 'axios';
  import SignInPublickUserToMeetingModal from "../components/meetings/signInPublickUserToMeetingModal";
  export default {
    name: "Meetings",
    components: {
      SignInPublickUserToMeetingModal,
      VueJitsiMeet: JitsiMeet
    },
    computed: {
      jitsiOptions () {
        return {
          roomName: 'default-room',
          noSSL: false,
          userInfo: {
            email: '',
            displayName: ``,
          },
          configOverwrite: {
            enableNoisyMicDetection: false
          },
          interfaceConfigOverwrite: {
            SHOW_JITSI_WATERMARK: false,
            SHOW_WATERMARK_FOR_GUESTS: false,
            SHOW_CHROME_EXTENSION_BANNER: false,
            TOOLBAR_BUTTONS: [
              "microphone", "camera", "desktop", "filmstrip","settings", "chat", "tileview", "raisehand", "highlight", "toggle-camera"
            ],
            MAIN_TOOLBAR_BUTTONS: ['microphone', 'camera', 'desktop']
          },
          onload: this.onIFrameLoad,
          prejoinPageEnabled: false
        };
      },
    },
    data(){
      return {
        isMeeting: false
      }
    },
    mounted() {
      if (this.$route.query.publicToken && this.$route.query.roomId && this.$route.query.typeName && this.$route.query.typeId && this.$route.query.meetingId && this.$route.query.companyId) {
        this.checkPublicToken()
      } else if (!this.$route.query.publicToken && this.$route.query.companyId && this.$route.query.meetingId && this.$route.query.typeId && this.$route.query.typeName && this.$route.query.token && this.$route.query.roomId){
        this.connect()
      } else {
        this.isMeeting = false
      }
    },
    methods: {
      checkPublicToken() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$route.query.token;
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/videoChat/checkPublicToken?companyId=${this.$route.query.companyId}&meetingId=${parseInt(this.$route.query.meetingId)}&roomId=${this.$route.query.roomId}&publicToken=${this.$route.query.publicToken}`)
            .then(response => {
              loader.hide()
              this.$refs.signInPublicUserMeetingModal.openModal()
            })
            .catch(error => {
              loader.hide()
              this.isMeeting = false;
              console.log('An error occurred:', error);
            });
      },
      connectPublic(form){
        this.jitsiOptions.userInfo.displayName = form.name;
        this.jitsiOptions.userInfo.email = form.email;
        this.jitsiOptions.roomName = this.$route.query.roomId;
        this.isMeeting = true;
      },
      connect(){
        let loader = this.$loading.show();
        // const data = {
        //   meetingId: parseInt(this.$route.query.meetingId),
        //   roomId: this.$route.query.roomId
        // };
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$route.query.token;
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/videoChat/connectUserChat?companyId=${this.$route.query.companyId}&meetingId=${parseInt(this.$route.query.meetingId)}&roomId=${this.$route.query.roomId}`)
          .then(response => {
            this.jitsiOptions.userInfo.displayName = response.data.user.name;
            this.jitsiOptions.userInfo.email = response.data.user.email;
            this.jitsiOptions.roomName = this.$route.query.roomId;
            // console.log('jitsiOptions', this.jitsiOptions)
            this.isMeeting = true;
            // console.log('jitsiRef', this.$refs.jitsiRef);
            // console.log(response);
          })
          .catch(error => {
            this.isMeeting = false;
            console.log('An error occurred:', error);
          });
        loader.hide()
      },
      onIFrameLoad () {
        // this.$refs.jitsiRef.executeCommand('displayName', '!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
        this.$refs.jitsiRef.addEventListener('participantJoined', this.onParticipantJoined);
        this.$refs.jitsiRef.addEventListener('videoConferenceLeft', this.videoConferenceLeft);
        // do stuff
      },
      startMeeting() {
        this.isMeeting = true
      },
      onParticipantJoined(e){
        console.log(e)
      },
      videoConferenceLeft(e) {
        console.log(e)
        this.isMeeting = false
      },
      click(){
        console.log(this.user);
        console.log(this.$refs.jitsiRef);
        console.log(this.jitsiOptions)
      }
    },
  }
</script>

<style lang="less" scoped>
    .meetings {
        background: #DfE8F0;
        z-index: 0;
        height: 100vh;
    }
    .content {
        display: flex;
        height: 100vh;
        /*padding-top: 50px;*/
    }
    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 10px;
        .meetings-header {
            margin: 10px 0;
        }
    }
</style>
